export enum EGameStoreEvents {
    GAME_STORE_UPDATED = 'GAME_STORE_UPDATED',
    GAME_STORE_SOUND_STATE_UPDATE = 'GAME_STORE_SOUD_STATE_UPDATE',
    GAME_STORE_SET = 'GAME_STORE_SET',
    GAME_STORE_PRELOADER_STATE_UPDATE = 'GAME_STORE_PRELOADER_STATE_UPDATE'
}
